export const TRACKING_CONST = {
    DATE_FORMAT: "MM-DD-YYYY",
    TRACKING_FIRST_MARGIN: '10px',
    EXPAND_HEIGHT: {
        height: "calc(100% - 48px)",
    }
}